import React from "react";
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography';
import { green } from '@material-ui/core/colors';
import ReplayIcon from '@material-ui/icons/Replay';
import Fab from '@material-ui/core/Fab';
import config from '../api_config.json';

const theme = createMuiTheme({
    palette: {
      primary: green,
    },
  });

const useStyles = makeStyles(theme => ({
    root: {
      width: '100%',
      overflowX: 'auto',
      'box-shadow': '0px 0px 5px rgba(0,0,0,0.3)'
    },
    table: {
      minWidth: 650,
    },
    title: {
      color: '#003087',
      margin: theme.spacing(1)
    },
    divider: {
      color: '#003087',
      'margin-top': theme.spacing(3),
      'margin-bottom': theme.spacing(6)
    },
    menuLink: {
      color: '#000000',
      'text-decoration': 'none',
      '&:hover': {
        'text-decoration': 'none'
      }
    },
    badge: {
      margin: theme.spacing(3),
    },
    bookNowTitle: {
      color: '#003087',
      'margin-top': theme.spacing(10),
    },
    bookNowBtn: {
      marginTop: theme.spacing(8),
      color: '#ffffff',
    },
    bookNowIcon: {
      marginRight: theme.spacing(1),
    },
  }));

export default function ErrorApi(props) {
    const classes = useStyles();
    const { errorMessage } = props;

    return (
        <Container maxWidth="lg">
            <Typography variant="h4" gutterBottom className={classes.bookNowTitle}>Oops. Something went wrong.</Typography>
            <Typography variant="h4" gutterBottom className={classes.title}>{errorMessage ? errorMessage : 'Cannot fetch lessons data'}. Please report the issue or try again <span aria-label="teacher" role="img">🤦‍♀️</span></Typography>
            <a href={config.siteUrl[process.env.REACT_APP_ENV]} className={classes.menuLink}>
            <ThemeProvider theme={theme}>
                <Fab variant="extended" color="primary" aria-label="like" className={classes.bookNowBtn}>
                <ReplayIcon className={classes.bookNowIcon} />
                Try again
                </Fab>
            </ThemeProvider>
            </a>
        </Container>
    )
}